import Api from "./Api";

class QuarterService {
    getQuarters = async () => {
        return await Api().get(`quarters`)
    };

    deleteQuarter = async ({quarterId}) => {
        return await Api().delete(`quarters/${quarterId}`)
    };

    saveQuarter = async ({quarterId, data}) => {
        return await Api().put(`quarters/${quarterId}`, data)
    };
}

export default new QuarterService();